import React from 'react';

import { greaterThanZeroOnly } from 'utils';
import Input from '../../../../components/Input';
import { PriceInputProps } from '../../../../../types/serviceProviders/serviceProvidersOffer';

const PriceInput = (props: PriceInputProps) => (
  <Input
    name={props.name}
    label={props.label}
    rules={[greaterThanZeroOnly, ...props.rules!]}
    layout={props.layout}
    validateFirst
  >
    <Input.InputField
      type="number"
      prefix="AED"
      suffix={props.suffix}
      onChange={props.onChange}
      value={props.value}
    />
  </Input>
);

PriceInput.defaultProps = {
  layout: 'vertical',
  rules: [],
  suffix: null,
};

export default PriceInput;
